/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserPanelItem from './user-panel-item';
import UserPanelItemDetail from './user-panel-item-detail';
import UserPanelItemUpdate from './user-panel-item-update';
import UserPanelItemDeleteDialog from './user-panel-item-delete-dialog';

const UserPanelItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserPanelItem />} />
    <Route path="new" element={<UserPanelItemUpdate />} />
    <Route path=":id">
      <Route index element={<UserPanelItemDetail />} />
      <Route path="edit" element={<UserPanelItemUpdate />} />
      <Route path="delete" element={<UserPanelItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserPanelItemRoutes;
